import { connect } from 'react-redux';

import trackABExperiment from '../../../helpers/trackABExperiment';
import * as actions from '../../../redux/actions';
import * as selectors from '../../../redux/selectors';

import ExerciseCompleted from './ExerciseCompleted';

const mapStateToProps = (state: any) => {
  const canRateChapter = selectors.selectCanRateChapter(state);
  const shouldSeeExerciseRating = selectors.selectShouldSeeExerciseRating(
    state,
  );

  // hide for last exercise of LTI exams
  const shouldSeeContinueButton = !(
    selectors.selectIsReducedOutlineCourse(state) &&
    selectors.selectExerciseIndex(state) + 1 ===
      selectors.selectCurrentChapterNbExercises(state)
  );

  return {
    userId: selectors.selectUserSettings(state).get('id'),
    courseId: selectors.selectCourse(state).get('id'),
    nextExPath: selectors.selectNeighborsExercises(state).nextExercise,
    userProgress: selectors.selectGlobalUserProgress(state),
    imageUrl: selectors.selectCourseImageURL(state),
    ltiStatus: selectors.selectUserExercise(state).toJS().ltiStatus,
    canRateChapter,
    shouldSeeExerciseRating,
    window: selectors.selectChapterWindow(state).toJS(),
    shouldSeeContinueButton,
    isNavigatingToNextExercise: selectors.selectIsNavigatingToNextExercise(
      state,
    ),
    xpWon: selectors.selectCurrentExerciseXpWon(state),
  };
};

const mapDispatchToProps = (dispatch: any) => {
  const submitExerciseRating = (nextPath: any) => (
    rating: any,
    feedback: any,
  ) => {
    dispatch(
      actions.epicSubmitExerciseRating({
        extraInfo: feedback,
        rating,
        nextPath,
      }),
    );
  };

  return {
    onClose: ({ id }: any) => dispatch(actions.hideCompletedExercise({ id })),
    submitRating: submitExerciseRating,
    showWindow: () => dispatch(actions.showWindow({ show: true })),
    onFirstTimeCompletedChapters: () =>
      dispatch(actions.firstTimeCompletedChapters()),
    onNext: (event: any) => {
      event.preventDefault();
      dispatch(actions.nextInternalExercise());
    },
    showChapterRating: (courseId: any, userId: any) => {
      const bucket = trackABExperiment('skipChapterRating', courseId, userId);
      if (bucket === 'control') {
        return dispatch(
          actions.showModal({
            modal: {
              ...selectors.MODAL_TYPE.CHAPTER_RATING,
              onFinish: () => {
                dispatch(actions.nextInternalExercise());
                dispatch(actions.removeModal());
              },
            },
          }),
        );
      }
      return dispatch(actions.nextInternalExercise());
    },
  };
};

const mergeProps = (stateProps: any, dispatchProps: any, ownProps: any) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  showChapterRating: () =>
    dispatchProps.showChapterRating(stateProps.courseId, stateProps.userId),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(ExerciseCompleted);
